import React, {useRef, useState, useCallback} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
const DOUBLE_CLICK = 250;

export const useCanvasMouse = ({
    forcePaths,
    effect,
    containerRef,
    ctxt,
    selected,
    startDragging,
    parameters,
    paths,
    macroPaths,
    setMacroToShow,
    setEffectParameterValues,
    getForceParameters
}) => {

    let lastClick = useRef(undefined);
    let [draggingForceStart, setDraggingForceStart] = useState(undefined);
    let [draggingForceEnd, setDraggingForceEnd] = useState(undefined);
    const onMouseDown = useCallback((e) => {
        let rect = containerRef.current.getBoundingClientRect();
        let x = (e.clientX - rect.left)*2;
        let y = (e.clientY - rect.top)*2;

        // first check for forces
        let i=1;
        for (let {start, end} of forcePaths.current) {
            if (ctxt.current.isPointInPath(start, x, y)) {
                e.stopPropagation();
                setDraggingForceStart(i);
                return;
            }
            if (ctxt.current.isPointInPath(end, x, y)) {
                e.stopPropagation();
                setDraggingForceEnd(i);
                return;
            }
            i++;
        }

        let macros = [
            ... selected.filter(x => effect.macros.includes(x)),
            ... effect.macros.filter(x => !selected.includes(x))];
        for (let param of [... parameters, ... macros]) {
            let path = paths.current[param.id] || macroPaths.current[param.id];
            if (!path) {
                continue;
            }
            if (ctxt.current.isPointInPath(path, x, y)) {
                startDragging(e, param);
                break;
            }
        }
    }, [startDragging, parameters, setDraggingForceStart, setDraggingForceEnd]);

    const onClick = useCallback((e) => {
        let rect = containerRef.current.getBoundingClientRect();
        let x = (e.clientX - rect.left) * 2;
        let y = (e.clientY - rect.top) * 2;
        let macros = [
            ... selected.filter(x => effect.macros.includes(x)),
            ... effect.macros.filter(x => !selected.includes(x))];
        for (let macro of macros) {
            let macroPath = macroPaths.current[macro.id];
            if (macroPath && ctxt.current.isPointInPath(macroPath, x,y)) {
                let now = new Date().getTime();
                if (now - lastClick.current <= DOUBLE_CLICK) {
                    setMacroToShow(macro);
                }
                lastClick.current = now;
                return;
            }
        }
    }, [setMacroToShow]);

    const onMouseUp = useCallback(() => {
        setDraggingForceStart(undefined);
        setDraggingForceEnd(undefined);
    }, [setDraggingForceStart, setDraggingForceEnd]); 

    const onMouseMove = useCallback((e) => {
        if (draggingForceStart === undefined &&
            draggingForceEnd === undefined) {
            return;
        }
        let rect = containerRef.current.getBoundingClientRect();
        let x = (e.clientX - rect.left);
        let y = (e.clientY - rect.top);

        let updates = {};
        if (draggingForceStart !== undefined) {
            let [xParameter, yParameter, dx, dy] = getForceParameters(draggingForceStart);
            let x2 = xParameter.get() + 0.25*dx.get();
            let y2 = yParameter.get() + 0.25*dy.get();
            let newX = x;
            let newY = HEIGHT - y;
            let _dx = x2 - newX;
            let _dy = y2 - newY;
            updates[xParameter.id] = xParameter.set(newX, false, true).value;
            updates[yParameter.id] = yParameter.set(newY, false, true).value;
            updates[dx.id] = dx.set(_dx*4, false, true).value;
            updates[dy.id] = dy.set(_dy*4, false, true).value;
        } else {
            let l = getForceParameters(draggingForceEnd);
            let [xParameter,yParameter,dxParameter,dyParameter] = l;
            let [_x, _y] = [xParameter.get(), HEIGHT - yParameter.get()];
            let dx = 4 * (x - _x);
            let dy = -4 * (y - _y);
            
            updates[dxParameter.id] = dxParameter.set(dx, false, true).value;
            updates[dyParameter.id] = dyParameter.set(dy, false, true).value;
            // endt
        }
        setEffectParameterValues(updates);
    }, [draggingForceStart, draggingForceEnd]);

    return {onMouseMove, onMouseUp, onMouseDown, onClick};
};
